import { Menu, MenuItem } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import { MenuButton } from '@tassat/button';
import { ActionTypes, actionText } from '@tassat/common-definitions';
import { ConfirmationWorkflowContext } from '@tassat/workflow';
import React from 'react';

import { DEFAULT_ICON_COLOR } from 'Lib/constant';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

interface ActionsDropdownMenuProps extends WithStyles<typeof muiStyles>{
    data: any;
    actions?: ActionTypes[];
    locked?: boolean;
}

const muiStyles = (theme: ApplicationMuiTheme) => ({
    menuPopup: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyDark ||
        '#333333'}`
    }
});

export function ActionsDropdownMenu(props: ActionsDropdownMenuProps) {
    const {
        classes,
        data,
        actions,
        locked
    } = props;

    const { preActionValidationAndConfig } = React.useContext(ConfirmationWorkflowContext).confirmationWorkflowState;

    const [ actionMenuAnchor, setActionMenuAnchor ] = React.useState<null | HTMLElement>(null);
    const handleActionMenuClose = () => setActionMenuAnchor(null);

    const menuItemClick = (action, data) => {
        handleActionMenuClose();
        preActionValidationAndConfig[action](data);
    };

    const renderActionMenuItemsFromData = () => {
        return Object.keys(preActionValidationAndConfig)
            .filter(actionString => {
                const action = parseInt(actionString, 10);
                if ((action === ActionTypes.lock && locked) || (action === ActionTypes.unlock && !locked)) {
                    return false;
                } else {
                    return true;
                }
            })
            .map(actionString => {
                const action = parseInt(actionString, 10);
                if (action === ActionTypes.lock || action === ActionTypes.unlock) {
                    return (
                        <MenuItem
                            key={`action_type_${action}`}
                            onClick={() => menuItemClick(action, data)}
                        >
                            {locked ? 'Unlock' : 'Lock'}
                        </MenuItem>
                    );
                } else {
                    return (
                        <MenuItem
                            key={`action_type_${action}`}
                            onClick={() => menuItemClick(action, data)}
                        >
                            {actionText(action)}
                        </MenuItem>
                    );
                }
            });
    };

    const renderActionMenuItemsFromProp = () => {
        return actions.map(action => {
            return (
                <MenuItem
                    key={`action_type_${action}`}
                    onClick={() => menuItemClick(action, data)}
                >
                    {actionText(action)}
                </MenuItem>
            );
        });
    };

    return (
        <>
            <MenuButton
                handleClick={(e) => setActionMenuAnchor(e.currentTarget)}
                iconColor={DEFAULT_ICON_COLOR}
                type={ActionTypes.show_actions}
            />
            <Menu
                anchorEl={actionMenuAnchor}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                id='actions-menu'
                keepMounted
                onClose={handleActionMenuClose}
                open={!!actionMenuAnchor}
                PopoverClasses={{ paper: classes.menuPopup }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                {actions ? renderActionMenuItemsFromProp() : renderActionMenuItemsFromData()}
            </Menu>
        </>
    );
}

export default withStyles(muiStyles)(ActionsDropdownMenu);